import shortid from "shortid";

// 75/25
export default [
  {
    tagName: "mj-column",
    attributes: {
      width: "75%",
      "vertical-align": "top",
    },
    children: [],
    uid: shortid.generate(),
  },
  {
    tagName: "mj-column",
    attributes: {
      width: "25%",
      "vertical-align": "top",
    },
    children: [],
    uid: shortid.generate(),
  },
];
